<template>
  <div class="dns-map">
    <div id="dns-map"></div>

    <div
      v-for="(item, index) in positions"
      :key="'marker-' + index"
      v-show="markerLoading"
      :class="[`dns-map-marker cursor-pointer marker-${index}`]"
      :ref="`mapMarker_${index}`"
      data-toggle="tooltip"
      size="sm"
      v-b-tooltip.hover.top="item.name"
    >
      <i class="fas fa-chart-network"></i>
    </div>
  </div>
</template>

<script>
import mapboxgl from 'mapbox-gl'

export default {
  name: 'DnsMap',
  data() {
    return {
      markerLoading: false,
      showDataCenterNode: false,
      showMap: false,
      showMarker: false,
      map: '',
      positions: [
        {
          name: 'İstanbul',
          geo_latitude: '41.0760501',
          geo_longitude: '29.0110552',
        },
        {
          name: 'Londra',
          geo_latitude: '51.5285582',
          geo_longitude: '-0.2416799',
        },
        {
          name: 'Frankfurt',
          geo_latitude: '50.1211277',
          geo_longitude: '8.4964823',
        },
        {
          name: 'Amsterdam',
          geo_latitude: '52.3546449',
          geo_longitude: '4.8339212',
        },
        {
          name: 'Toronto',
          geo_latitude: '43.7181557',
          geo_longitude: '-79.5181403',
        },
        {
          name: 'Bangalore',
          geo_latitude: '12.95396',
          geo_longitude: '77.4908548',
        },
        {
          name: 'San Francisco',
          geo_latitude: '37.7576948',
          geo_longitude: '-122.4726194',
        },
        {
          name: 'New York',
          geo_latitude: '40.6974034',
          geo_longitude: '-74.1197636',
        },
      ],
    }
  },
  mounted() {
    this.loadMapComponent()
  },
  methods: {
    loadMapComponent() {
      if (!this.showMap) {
        mapboxgl.accessToken =
          // 'pk.eyJ1IjoiYnVyYWtrYXNpa2NpIiwiYSI6ImNsZ2Y0dWkyajAwejczZGxjZ3pmdXcyMGYifQ.n8jzE0kmeXsMUHrrH9Fcsw'
          'pk.eyJ1IjoicGx1c2Nsb3VkczIiLCJhIjoiY2szZm9ibzF4MDZnajNwcnowNWNvemxocyJ9.l67c2UvyWeQCgIvvntB6Ig'
        this.map = new mapboxgl.Map({
          container: 'dns-map',
          // style: 'mapbox://styles/mapbox/light-v10',
          style: 'mapbox://styles/mapbox/dark-v10',
          center: [-25, 31], // starting position [lng, lat]
          zoom: 1.4, // starting zoom
          interactive: true,
          attributionControl: false,
        })

        setTimeout(() => {
          this.map.resize()
        }, 20)
        this.showMap = true

        setTimeout(() => {
          this.positions.forEach((marker, index) => {
            if (this.$refs['mapMarker_' + index]) {
              new mapboxgl.Marker(this.$refs['mapMarker_' + index][0])
                .setLngLat([marker.geo_longitude, marker.geo_latitude])
                .addTo(this.map)
              this.showMarker = true
            }
          })
        }, 50)

        setTimeout(() => {
          this.markerLoading = true
        }, 500)
      } else {
        setTimeout(() => {
          this.map.resize()
        }, 20)
      }
    },
  },
}
</script>

<style lang="scss">
.dns-map {
  #dns-map {
    position: relative;
    width: 100%;
    height: 100vh;
    max-height: 590px;
    overflow: hidden;
    border-radius: 12px;
  }
  .map-wrapper {
    position: relative;
    width: 100%;
    height: 500px;
  }

  .dns-map-marker {
    position: absolute;
    width: 26px;
    height: 26px;
    top: 0;
    left: 0;
    padding-top: 2px;
    border-radius: 100%;
    background-color: #fff;
    border: 1px solid #e5eaee;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    animation: blink 1s step-start 1s infinite;
    z-index: 2;

    &.marker-0 {
      animation-delay: 0.5s;

      i {
        animation-delay: 0.5s;
      }
    }
    &.marker-1 {
      animation-delay: 0.75s;

      i {
        animation-delay: 0.75s;
      }
    }
    &.marker-2 {
      animation-delay: 1s;

      i {
        animation-delay: 1s;
      }
    }
    &.marker-3 {
      animation-delay: 0.5s;

      i {
        animation-delay: 0.5s;
      }
    }
    &.marker-4 {
      animation-delay: 1s;

      i {
        animation-delay: 1s;
      }
    }
    &.marker-5 {
      animation-delay: 0.5s;

      i {
        animation-delay: 0.5s;
      }
    }
    &.marker-6 {
      animation-delay: 0.25s;

      i {
        animation-delay: 0.25s;
      }
    }
    &.marker-7 {
      animation-delay: 0.75s;

      i {
        animation-delay: 0.75s;
      }
    }

    i {
      position: absolute;
      color: #00baf2;
      font-size: 12px;
      line-height: 12px;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      animation: blink 1s step-start 1s infinite;
    }
  }
}

@keyframes blink {
  50% {
    color: #fff;
    background-color: #00baf2;
  }
}
</style>
